import { styled } from '@mui/material/styles'
import { NavLink, type NavLinkProps } from 'react-router-dom'

const StyledNavLink = styled(NavLink)(({ theme }) => ({
  width: '100%',
  textDecoration: 'none',
  '.MuiSvgIcon-root': {
    display: 'none'
  },
  '&.active.menu-item': {
    '.MuiSvgIcon-root': {
      display: 'block'
    },
    '.MuiListItemButton-root': {
      backgroundColor: theme.palette.action.selected
    }
  },
  '.MuiTypography-root': {
    color: theme.palette.text.primary
  }
}))

function DrawerMenuItemLink({
  children,
  hasSubMenu,
  ...props
}: NavLinkProps & {
  children: React.ReactNode
  hasSubMenu?: boolean
}) {
  return hasSubMenu ? <span>{children}</span> : <StyledNavLink {...props}>{children}</StyledNavLink>
}

export default DrawerMenuItemLink
